import React from 'react';
// import jQuery from 'jquery';

class BeWise_Footer extends React.Component {

    constructor(props) {
        super(props);
        //const { history } = this.props;
        this.state = {
            logged_user_name: ''
        };
    }

    componentDidMount() {
  
        // console.log('user data', this.state.auth_data)
    }

    render() {
        return (
              
            <React.Fragment>

            <footer class="footer">
            <div class="text-right">
              <span class="text-center text-sm-left d-block d-sm-inline-block black-text">Copyright © <a href="https://www.bewise.in/" target="_blank">BeWise</a> 2023</span>
              
            </div>
            </footer>

            </React.Fragment>

        )
    }
}


export default BeWise_Footer;


// WEBPACK FOOTER //
// ./src/components/bewise/footer.jsx